// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 79 ? "363642f4" : chunkId) + "." + {"35":"e18ec8416d6726ef","79":"d482bd944244e9d2","92":"c3f632e4a2ea9c6c","114":"1df00644a930ac7c","310":"cef60121eef6b194","732":"a20a8b1f6dfd41e4","753":"8c997542dcce3eda","955":"ce28039763780a0c"}[chunkId] + ".js";
};